import {
  Button,
  COLORS,
  COMMON_STYLES,
  TEXT_STYLES,
  TYPOGRAPHY,
  VARIANTS_STYLES,
} from "@dehaat/dds";
import React from "react";
import { StyleSheet, Text, View } from "react-native";

interface Props {
  farmerNumber: string;
  onCreateProfileClick: () => void;
}

const NoFarmerFound = ({ farmerNumber, onCreateProfileClick }: Props) => {
  return (
    <View style={styles.container}>
      <Text
        style={[
          TYPOGRAPHY.TEXT2,
          VARIANTS_STYLES.MEDIUM,
          TEXT_STYLES.textNeutral70,
        ]}
      >
        Farmer profile not found
      </Text>
      <Text
        style={[
          TYPOGRAPHY.TEXT2,
          VARIANTS_STYLES.MEDIUM,
          TEXT_STYLES.textNeutral70,
        ]}
      >
        {`"${farmerNumber}"`}
      </Text>

      <Button
        onClick={onCreateProfileClick}
        text={"Create Farmer profile"}
        buttonStyle={COMMON_STYLES.mt1}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    height: 205,
    borderRadius: 16,
    borderColor: COLORS.neutral20,
    borderWidth: 1,
    alignItems: "center",
    justifyContent: "center",
  },
});

export default NoFarmerFound;
